/* @flow */

import {
  successBgColor,
  successTextColor,
  warningBgColor,
  warningTextColor,
  errorBgColor,
  errorTextColor,
} from 'plugin/light/style/color';
import { listReset } from 'src/shared/app/base/style/token/helper';

/*
 |------------------------------------------------------------------------------
 | Styles
 |------------------------------------------------------------------------------
 */

export default {
  list: {
    extend: listReset,

    display: 'flex',
    flexWrap: 'wrap',
  },
  item: {
    margin: [0, 10, 10, 0],
  },
  swatch: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: 160,
    height: 80,
    padding: [20],

    fontWeight: 700,
  },
  success: {
    '& $swatch': {
      backgroundColor: successBgColor,
      color: successTextColor,
    },
  },
  warning: {
    '& $swatch': {
      backgroundColor: warningBgColor,
      color: warningTextColor,
    },
  },
  error: {
    '& $swatch': {
      backgroundColor: errorBgColor,
      color: errorTextColor,
    },
  },
};
